import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  padding: 20px 28px;
  border-bottom: 1px solid ${colors.outlineVariant}30;
`;

export const HeaderInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;

  h3 {
    font-size: 18px;
    font-weight: 700;
    color: ${colors.onSurface};
  }

  p {
    font-size: 12px;
    color: ${colors.onSurfaceVariant};
    margin-top: 2px;
  }
`;

export const Avatar = styled.img`
  width: 40px;
  height: 40px;
  flex-shrink: 0;

  border-radius: ${radius.full};
  border: 2px solid ${colors.primary};
  object-fit: cover;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
`;

export const Badge = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: ${colors.primary};
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 36px;
  height: 36px;
  flex-shrink: 0;

  background: transparent;
  border: none;
  border-radius: ${radius.DEFAULT};
  cursor: pointer;
  color: ${colors.onSurfaceVariant};

  transition: all 0.2s;

  &:hover {
    color: ${colors.onSurface};
    background-color: ${colors.surfaceContainer};
  }
`;
